import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';
import { sendMixPanelFilterEvent } from './index';

export const reportIndustrySelectionChangeEvent = (type, { text }) => {
    const bigQueryValues = getBQClickFields({
        type: type.BigQuery,
        text,
        elementName: 'industry_filter',
        componentName: 'reviews_header',
    });
    Object.assign(bigQueryValues, {
        feature: {
            name: 'gig_reviews',
        },
    });
    tracker.sendBQEvent(bigQueryValues);

    sendMixPanelFilterEvent({ filterType: type.Mixpanel });
};

export const reportIndustrySelectionClickEvent = (type) => {
    const bigQueryValues = getBQClickFields({
        type: type.BigQuery,
        elementName: 'industry_filter',
        componentName: 'reviews_header',
    });
    Object.assign(bigQueryValues, {
        feature: {
            name: 'gig_reviews',
        },
    });
    tracker.sendBQEvent(bigQueryValues);
};
